// src/components/Signup.js
import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signOut,
} from 'firebase/auth';
import { toast } from 'react-toastify';

function Signup() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleSignup = async (e) => {
    e.preventDefault();
    if (submitting) return;

    setSubmitting(true);

    try {
      const userCred = await createUserWithEmailAndPassword(
        auth,
        email.trim().toLowerCase(),
        password
      );
      const user = userCred.user;
      const plan = searchParams.get('plan');

      await sendEmailVerification(user);

      // Do not create users/{uid} until email ownership is verified.
      // This keeps automated/unverified signups out of application data.
      await signOut(auth);

      if (window.gtag) {
        window.gtag('event', 'sign_up_pending_verification', {
          send_to: 'G-XMGH0SPFBV',
          event_category: 'user',
          method: 'email',
        });
      }

      toast.success('Check your email to verify your account before signing in.');
      const params = new URLSearchParams({ verifyEmail: '1' });
      if (plan) params.set('plan', plan);
      navigate(`/login?${params.toString()}`, { replace: true });
    } catch (error) {
      console.error('Signup error:', error);
      toast.error('Unable to create an account. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <form onSubmit={handleSignup} className="bg-white p-6 rounded shadow-md w-full max-w-sm">
        <h1 className="text-2xl font-bold mb-4">Sign Up</h1>

        <label className="block mb-2">
          <span className="text-gray-700">Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 block w-full border border-gray-300 rounded p-2"
            autoComplete="email"
            maxLength={254}
            required
          />
        </label>

        <label className="block mb-4">
          <span className="text-gray-700">Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 block w-full border border-gray-300 rounded p-2"
            autoComplete="new-password"
            minLength={12}
            maxLength={128}
            required
          />
          <span className="text-xs text-gray-500">Use at least 12 characters.</span>
        </label>

        <button
          type="submit"
          disabled={submitting}
          className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition-colors w-full disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {submitting ? 'Creating account…' : 'Create Account'}
        </button>
      </form>
    </div>
  );
}

export default Signup;
